import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category useLeaveEarly */
export type TypeLeaveEarlyParams = {
  /** 조퇴 시각 */
  earlyEndAt: string;
  /** 어드민 코드 */
  verificationCode: string;
};

/** @category useLeaveEarly */
export type TypeLeaveEarlyResponse = {
  message: string;
  code: string;
  data: {
    earlyEndAt: string;
  };
};

/**
 * @description 작업자의 조퇴를 처리하는 api 요청에 사용되는 커스텀 훅
 */
export const useLeaveEarly = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeLeaveEarlyParams) => {
      const endpoint = '/early-end-commutes';
      return axiosInstance.post<TypeLeaveEarlyResponse>(endpoint, params);
    },
  });

  const requestLeaveEarly = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeLeaveEarlyParams;
    onSuccess?: (res: TypeLeaveEarlyResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestLeaveEarly;
};
